export default {
  minhasEmpresas: [],
  minhaConta: {},
}
